export default "__VITE_ASSET__C5qEveyq__"